import styled from 'styled-components';

export const MobileDropdownMenuSubSectionList = styled.ul`
    padding: 0px;
    list-style-type: none;
    list-style-position: outside;
    list-style: none;
    margin-inline: 0px;
    padding-inline: 0px;
    margin-block: 0px;
`;
